import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export type UpdateProductOptions = {
  chameleonRequestInstance: ChameleonRequest;
  asosBagSessionToken: string;
  bagId: string;
  bagItemId: string;
  variantId: number;
  quantity: number;
  authHeader: string;
  store: string;
  lang: string;
  expand?: ExpandOptions;
};

export async function updateProduct({
  chameleonRequestInstance,
  asosBagSessionToken,
  bagId,
  bagItemId,
  variantId,
  quantity,
  authHeader,
  store,
  lang,
  expand,
}: UpdateProductOptions) {
  const expandQueryValue = buildExpandQueryValue(expand);

  const url = getApiUrl({
    path: `/commerce/bag/v4/bags/${bagId}/product/${bagItemId}/update`,
    searchParams: {
      lang,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.post<BagResponseV4>(url, {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
        "asos-bag-session-token": asosBagSessionToken,
        Authorization: authHeader,
      },
      body: JSON.stringify({
        variantId,
        quantity,
      }),
    });

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
